module.exports = __webpack_public_path__ + "assets/img/9b280d6800f27de5932819e3233a693d.svg";